import { OfficialDispatchImpl } from "../data/OfficialDispatchImpl";
import { IOfficialDispatchRepository } from "../domain/repositories/IOfficialDispatchRepository";
import { OfficialDispatchUseCase } from "../domain/useCases/OfficialDispatchUseCase";
import { OfficialDispatchViewModel } from "../presentation/viewModel/OfficialDispatchViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class OfficialDispatchInjection extends InjectionModule {
  private static readonly officialDispatchRepositoryToken = Symbol(
    "IOfficialDispatchRepository",
  );
  private static readonly officialDispatchUseCaseToken = Symbol(
    "OfficialDispatchUseCase",
  );
  private static readonly officialDispatchViewModelToken = Symbol(
    "OfficialDispatchViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.officialDispatchRepositoryToken,
      useClass: OfficialDispatchImpl,
    },
    {
      scope: "otherRepo",
      token: this.officialDispatchUseCaseToken,
      useClass: OfficialDispatchUseCase,
    },
    {
      scope: "viewModel",
      token: this.officialDispatchViewModelToken,
      useClass: OfficialDispatchViewModel,
    },
  ];

  static getRepo(): IOfficialDispatchRepository {
    return this.resolve(this.officialDispatchRepositoryToken);
  }

  static getUseCase(): OfficialDispatchUseCase {
    return this.resolve(this.officialDispatchUseCaseToken);
  }
}
